<template>
  <main>
    <div class="container">
      <h1 class="mb-6 title-1">
        {{ title }}
      </h1>
      <section class="mb-8">
        <h2 v-html="sections.policy.title" class="mb-4 title-3 uppercase" />
        <p v-for="(paragraph, key) in sections.policy.paragraphs" :key v-html="paragraph" class="mt-4" />
      </section>
      <section class="mb-8">
        <div v-if="sections.claim" class="w-full md:w-1/3">
          <vf-select v-model="warrantyOption" :options="sections.claim.options">
            <span>{{ sections.claim.label }}</span>
          </vf-select>
        </div>
        <div class="mt-8">
          <template v-if="warrantyOption === 'submit'">
            <h2 class="mb-4 title-2">
              {{ sections.submit.title }}
            </h2>
            <p class="mb-4">
              {{ sections.submit.subtitle }}
            </p>
            <div class="mb-8 flex gap-4 <md:f-col">
              <vf-button
                v-for="({ label, value }, key) in sections.submit.options"
                :key
                class="md:w-1/3"
                size="xs"
                @click="handleItemAgeBtnClick(value)"
              >
                {{ label }}
              </vf-button>
            </div>
            <template v-if="itemAge">
              <div
                v-if="sections.submit.sections[itemAge].content"
                v-html="sections.submit.sections[itemAge].content"
                class="mb-4"
              />
              <form-contact-us v-if="sections.submit.sections[itemAge].showContactForm" :show-title="false" />
              <vf-select
                v-if="sections.submit.sections[itemAge].showPurchaseOptions"
                v-model="purchaseLocation"
                class="w-full md:w-1/2"
                :options="options.purchase.options"
              >
                {{ options.purchase.label }}
              </vf-select>
              <vf-button v-if="sections.submit.sections[itemAge].showReturnButton" to="/order-status">
                {{ sections.submit.returnButtonLabel }}
              </vf-button>
              <div v-if="purchaseLocation" class="my-8">
                <div v-html="sections.purchase[purchaseLocation].content" />
                <form-warranty v-if="sections.purchase[purchaseLocation].showWarrantyForm" />
                <form-contact-us v-if="sections.purchase[purchaseLocation].showContactForm" :show-title="false" />
              </div>
              <form-warranty v-else-if="sections.submit.sections[itemAge].showWarrantyForm" />
            </template>
          </template>
          <template v-if="warrantyOption === 'requestRepair'">
            <div v-html="sections.requestRepair.content" />
          </template>
          <template v-if="warrantyOption === 'checkStatus'">
            <template v-if="sections.checkStatus.title">
              <h2 v-html="sections.checkStatus.title" class="mb-4 title-2" />
              <p class="mb-4">
                <base-interpolator :content="sections.checkStatus.content1">
                  <template #sign-in="{ args: [message] }">
                    <base-button
                      class="underlined"
                      data-test-id="warranty-check-status-sign-in"
                      @click="DialogSignIn.open()"
                    >
                      {{ message }}
                    </base-button>
                  </template>
                </base-interpolator>
              </p>
              <div v-html="sections.checkStatus.content2" />
            </template>
            <div v-else v-html="sections.checkStatus.content" />
            <form-contact-us :show-title="showContactUsFormTitle" />
          </template>
        </div>
      </section>
      <cms-section v-if="eSpots?.[0]" context="warranty-page" lazy-media :section="eSpots[0]" />
    </div>
  </main>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  'change-page-title': [title: string]
}>()

const { DialogSignIn } = useDialogsStore()

const { $seo } = useNuxtApp()

const { data, error } = await useApi().internal.getStaticPage('help/warranty')

if (!data.value) throw createError({ ...error.value!, fatal: true })

const eSpots = (await useCms().getSections.generic('warranty')).data.value?.content?.sections

const { title, sections, options } = data.value

emit('change-page-title', $seo.helpWarranty.title)

const warrantyOption = ref(sections.claim ? undefined : 'submit')
const itemAge = ref<string>()
const purchaseLocation = ref<string>()

const handleItemAgeBtnClick = (age: string) => {
  itemAge.value = age
  if (age !== itemAge.value) purchaseLocation.value = ''
}
const {
  showContactUsFormTitle
} = useAppConfig().pages.help
</script>
